import { FunctionComponent } from "react";
import { Global, css } from "@emotion/react";
import { fontKrub } from "./fonts";
import { Colors } from "./colors";

export const GlobalStyleSheet: FunctionComponent = () => {
  return <Global styles={GlobalStyles} />;
};

const BASE_FONT_SIZE = 14;

const GlobalStyles = css`
  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }

  html {
    height: 100%;

    font-size: ${BASE_FONT_SIZE}px;
    font-weight: 300;
  }

  body {
    ${fontKrub()};
    background-color: ${Colors.VERY_LIGHT_BLUE};

    margin: 0;
    padding: 0;
    line-height: 1.15rem;
    height: 100%;

    overscroll-behavior-y: none;
  }

  #root {
    height: 100%;
  }

  ::placeholder {
    color: ${Colors.DARK_GRAY};
  }

  ::selection {
    color: white;
    background: ${Colors.PURPLE};
  }

  // force font for these fields
  input,
  textarea,
  select {
    ${fontKrub()};
    font-size: ${BASE_FONT_SIZE}px;
    font-weight: 300;
  }

  p {
    margin-top: 0;
  }
`;
